import { atom } from 'nanostores';
import { userStore } from './user';

const _tokenStore = atom<string | undefined>();

export function setToken(token: string) {
  _tokenStore.set(token);
}

export function getToken() {
  if (!userStore.loggedIn.get()) {
    return Promise.resolve(undefined);
  }

  if (_tokenStore.get()) {
    return Promise.resolve(_tokenStore.get());
  }

  /**
   * We could be in a state where the user is logged in but the token is
   * not fetched yet. To fix this, we wrap it in a promise.
   */
  return new Promise<string>((resolve) => {
    const unsubscribe = _tokenStore.subscribe((token) => {
      if (token) {
        queueMicrotask(() => unsubscribe());

        resolve(token);
      }
    });
  });
}

if (import.meta.env.DEV) {
  Object.assign(globalThis, { tokenStore: _tokenStore });
}
